import { useCostCenter } from '@/features/costCenters/useCostCenter'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import CostCenterForm from '../components/CostCenterForm'

const AddCostCenter = () => {
  const { useCreateCostCenter } = useCostCenter()
  const createCostCenter = useCreateCostCenter()
  const navigate = useNavigate()
  const newCostCenter = {
    code: '',
    name: '',
    description: '',
    workInstructionAllowed: false,
    approvers: [],
  }

  const onSubmit = async (data) => {
    createCostCenter.mutate(data, {
      onSuccess: () => {
        navigate('/admin/costCenters')
      },
    })
  }

  return <CostCenterForm onSubmitAction={onSubmit} costCenter={newCostCenter} />
}

export default AddCostCenter
